import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission } from '../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/profile-settings/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.EDIT_MY_ACCOUNT_MANAGEMENT }) ||
      !!context.userPermissions.hasAllowedPermission({
        path: PAGE_PATHS.EDIT_MY_ACCOUNT_MANAGEMENT,
        permission: Permission.UPDATE,
      });
    context.validatePermissions({ isAllowed, preload });
  },
});
